import { render, staticRenderFns } from "./d-activity-single.vue?vue&type=template&id=63c06a17&scoped=true&"
import script from "./d-activity-single.vue?vue&type=script&lang=js&"
export * from "./d-activity-single.vue?vue&type=script&lang=js&"
import style0 from "./d-activity-single.vue?vue&type=style&index=0&id=63c06a17&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63c06a17",
  null
  
)

export default component.exports